import OrderChangeRequested from '../../../../application/order/events/OrderChangeRequested';
import State from '../../../../application/core/State';
import { getProductStockLevel } from '../../../Product';
import OrderValidationResult from '../OrderValidationResult';
import { roundValueToMinPackageSize } from '../../../roundValueToPackageSize';
import StockError from '../error';

export default (event: OrderChangeRequested, state: State): OrderValidationResult => {
    const itemStock: number | undefined = getProductStockLevel(state.products.orderProducts, event.product.articleId, event.sku);
    if (itemStock === undefined || itemStock >= event.value) {
        return {
            value: event.value,
            notification: StockError.Null
        };
    }
    const roundedValue: number = roundValueToMinPackageSize(itemStock!, event.product.packageSize);
    return {
        value: roundedValue,
        notification: StockError.StockValueIsNotAvailable
    };
};



// WEBPACK FOOTER //
// ./src/domain/orders/validators/stock/checkIfStockOrderIsAvailable.ts